const LHSidebarItems = [
  {
    icon: "home",
    label: "Home",
    description: "",
    url: "/home",
    disabled: false,
  },
  {
    icon: "observations",
    label: "Observations",
    description:
      "Dashboard to complete Pulse Checks and Observations. Contains history of past observations as well as a list of all employees, the dates of the previous observations, and key metric information.",
    url: "/observations",
    disabled: false,
  },
  {
    icon: "shift",
    label: "Shift Handover",
    description:
      "Process for structured shift handovers between Site supervisor to ensure a smooth transition and site preparedness. It emphasizes the importance of communication and a pre-shift walkthrough to relay key information, fostering consistency and connection across shifts.",
    url: "/shift-handover",
    disabled: false,
  },
  {
    icon: "person",
    label: "Employee Update",
    description:
      "Manage employee information and status. View, add, edit and delete employee records, track last observations and pulse checks, and manage employee status changes.",
    url: "/employee-update",
    disabled: false,
  },
  {
    icon: "people",
    label: "Leadership Walk",
    description:
      "Daily floor walks to assess facility readiness and ensure process adherence. It serves as a feedback mechanism, enabling leaders to provide on-the-spot coaching and develop immediate action plans to maintain operational standards.",
    url: "/leadership-walk",
    disabled: false,
  },
  {
    icon: "walk",
    label: "SPARC Walk",
    description:
      "Focuses on engaging frontline workers and assessing the impact of KPIs in targeted areas. The walk promotes leadership visibility on the floor, enabling leaders to observe, document, and address performance and safety standards.",
    url: "/spark-walk",
    disabled: false,
  },
  {
    icon: "racking",
    label: "NHO",
    description:
      "Track performance, monitor training completion, and manage expectations for new hires. This module provides a centralized hub to set goals, evaluate progress, and support a seamless transition as employees step into their new roles.",
    url: "/nho",
    disabled: false,
  },
  {
    icon: "racking",
    label: "Racking Inspection",
    description:
      "This module provides a centralized hub for managing the racking inspection process.  Site provides current inspection documents, historical list of identified damaged components and tracks documentation of the repair status.",
    url: "/racking-inspection",
    disabled: false,
  },
  {
    icon: "dashboard",
    label: "Quality Audit",
    description: "Manage new employee onboarding process",
    url: "/quality-audit",
    disabled: false,
  },
  {
    icon: "evaluation",
    label: "Site Evaluation",
    description:
      "Track and assess overall site performance, with data recorded exclusively by COE (Center of Excellence) users. This ensures accurate, consistent performance metrics, enabling targeted analysis and continuous improvement initiatives to maintain high operational standards.",
    url: "/site-evaluation",
    disabled: false,
  },
  {
    icon: "analytics",
    label: "Analytics",
    description:
      "Access the Analytics Hub for consolidated metrics, trends, and operational insights.",
    url: "/analytics",
    disabled: false,
  },
  {
    icon: "labor",
    label: "Labor Optimization",
    description:
      "Direct Labor Operations module for managing workforce efficiency, task allocation, and labor optimization. Provides comprehensive tools for tracking productivity and operational metrics.",
    url: "/dlo",
    disabled: true,
  },
    {
      icon: "ticket",
      label: "Ticketing Portal",
      description:
        "Submit and manage support tickets. Create new tickets, view ticket history, and track ticket status.",
      url: "/ticketing-portal",
      disabled: false,
    },
  {
    icon: "truck",
    label: "Perfect Truck",
    description:
      "Certify and verify truck equipment readiness before deliveries. Track certifications, review equipment status, and manage approvals across routes.",
    url: "/perfect-truck",
    disabled: false,
  },
  {
    icon: "harbor",
    label: "Harbor",
    description:
      "Unified entry point for delivery-related workflows. Access Perfect Truck and Delivery RPM based on your role. Visibility is role-based.",
    url: "/harbor",
    disabled: false,
  },
  {
    icon: "contactus",
    label: "Contact us/Feedback",
    description:
      "Feedback and Issue Reporting Form: Share Your Observations and Suggestions.",
    url: "/contact-us",
    disabled: false,
  },
];

export default LHSidebarItems;
